import { PoOperationCompletionModel } from "./po-operation-completion.model";


export class DaySummaryModel {
    date: string; // today
    poInfo: PoInfoModel[];
    operationsCompletionInfo: PoOperationCompletionModel[];

    constructor(date: string, poInfo: PoInfoModel[], operationsCompletionInfo: PoOperationCompletionModel[]) {
        this.date = date;
        this.poInfo = poInfo;
        this.operationsCompletionInfo = operationsCompletionInfo;
    }
}

export class PoInfoModel {
    poNumber: string;
    poDesc: string;
    schedule: string;
    deliveryDate: string;
    buyer: string;

    constructor(poNumber: string, poDesc: string, schedule: string, deliveryDate: string, buyer: string) {
        this.poNumber = poNumber;
        this.poDesc = poDesc;
        this.schedule = schedule;
        this.deliveryDate = deliveryDate;
        this.buyer = buyer;
    }
}